var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8503 2.70905C10.4484 2.6683 10.1665 2.99866 10.1665 3.33331V12.6667C10.1665 12.9428 10.3904 13.1667 10.6665 13.1667C10.9426 13.1667 11.1665 12.9428 11.1665 12.6667L11.1665 3.90895C11.176 3.91634 11.1856 3.92399 11.1955 3.93191C11.4106 4.10464 11.6663 4.36155 12.0461 4.74481L12.978 5.68506C13.1724 5.88119 13.489 5.88261 13.6851 5.68822C13.8813 5.49383 13.8827 5.17725 13.6883 4.98112L12.7361 4.02036C12.3818 3.66291 12.0864 3.36478 11.8217 3.15222C11.5441 2.92927 11.2523 2.75969 10.8968 2.71438C10.8813 2.7124 10.8658 2.71063 10.8503 2.70905Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83317 3.33332C5.83317 3.05718 5.60931 2.83332 5.33317 2.83332C5.05703 2.83332 4.83317 3.05718 4.83317 3.33332L4.83317 11.9575C4.82369 11.9501 4.81403 11.9425 4.80416 11.9346C4.58908 11.7618 4.33339 11.5049 3.95353 11.1217L3.02163 10.1814C2.82724 9.98528 2.51066 9.98387 2.31453 10.1783C2.1184 10.3726 2.11699 10.6892 2.31138 10.8854L3.26359 11.8461C3.61785 12.2036 3.91332 12.5017 4.178 12.7143C4.45561 12.9372 4.74738 13.1068 5.10284 13.1521C5.53658 13.2074 5.83317 12.8477 5.83317 12.4991L5.83317 3.33332Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSwap);
export default __webpack_public_path__ + "static/media/ArrowSwap.fd7680786fb15b2490aa125964ac651c.svg";
export { ForwardRef as ReactComponent };